import { render, staticRenderFns } from "./BrazilCheckboxField.vue?vue&type=template&id=7f938ee4&scoped=true&"
import script from "./BrazilCheckboxField.vue?vue&type=script&lang=js&"
export * from "./BrazilCheckboxField.vue?vue&type=script&lang=js&"
import style0 from "./BrazilCheckboxField.vue?vue&type=style&index=0&id=7f938ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f938ee4",
  null
  
)

export default component.exports